
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DynamicField, DynamicFieldOutput } from "@/types/dynamic-data";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import DynamicDataFields from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFields.vue";
import Icon from "@/components/UI/Icon.vue";
import IconButton from "@/components/UI/IconButton.vue";
import Dialog from "@/components/UI/Dialog.vue";
import {
  getShortcodeFromDynamicField,
  getSlugFromDynamicFieldOutput
} from "@/lib/dynamic-data/utils";
import VideoInput from "@/components/Reusable/CustomInputs/VideoInput.vue";
import DynamicDataPromotionVideo from "@/components/Subscription/DynamicDataPromotionVideo.vue";
import { configStore } from "@/store/store-accessor";
import { isDynamicFieldProOnlyAndUserIsOnFreeTier } from "@/lib/subscriptions/free-mode";
import { DynamicFieldReturnType } from "@/types/dynamic-property-path";

@Component({
  components: {
    DynamicDataPromotionVideo,
    VideoInput,
    Dialog,
    IconButton,
    Icon,
    DynamicDataFields,
    DropdownInput,
    TextInput
  }
})
export default class DynamicDataDialog extends Vue {
  @Prop()
  value!: boolean;

  @Prop()
  dynamicField: DynamicFieldOutput | undefined;

  @Prop()
  accepts!: DynamicFieldReturnType | false;

  @Prop({ default: false })
  proOnly!: boolean;

  chosenField?: DynamicField;

  get selectedField() {
    return this.dynamicField
      ? getSlugFromDynamicFieldOutput(this.dynamicField)
      : null;
  }

  get dynamicProOnly() {
    return this.proOnly && configStore.subscriptionMode === "free";
  }

  setField(field: DynamicField) {
    if (isDynamicFieldProOnlyAndUserIsOnFreeTier(field)) {
      alert("Please upgrade to pro to use this field.");
      return;
    }

    this.chosenField = field;
    this.saveAndClose();
  }

  reset() {
    this.chosenField = undefined;
  }

  goBack() {
    this.reset();
  }

  close() {
    this.$emit("close");
  }

  save() {
    if (!this.chosenField) {
      this.close();

      return;
    }

    const chosenFieldAttributes = this.chosenField.defaultAttributes ?? {};

    const shortcode = getShortcodeFromDynamicField(
      chosenFieldAttributes,
      this.chosenField
    );

    this.$emit("selected", {
      field: this.chosenField.slug,
      shortcode,
      attributes: chosenFieldAttributes
    });
  }

  saveAndClose() {
    this.save();
    this.close();
    this.reset();
  }
}
